/**
 * A custom React hook that provides a simple API to store and retrieve string variables
 * on a global custom object attached to the `window` (or `globalThis`) object.
 *
 * This hook ensures that a global object `__APP__CUSTOM__` exists on `globalThis`,
 * and exposes `setVariable` and `getVariable` functions to interact with it.
 *
 * @returns An object containing:
 * - `setVariable(name: string, value: string)`: Sets a string variable in the global custom object.
 * - `getVariable(name: string): string | undefined`: Retrieves a string variable from the global custom object.
 *
 * @example
 * const { setVariable, getVariable } = useAppVariableGlobalToWindow();
 * setVariable('token', 'abc123');
 * const token = getVariable('token'); // 'abc123'
 */
export const useAppVariableGlobalToWindow = () => {
    const appWindow = globalThis;
    if (!appWindow.__APP__CUSTOM__) {
        appWindow.__APP__CUSTOM__ = {};
    }
    const setVariable = (name, value) => {
        appWindow.__APP__CUSTOM__[name] = value;
    };
    const getVariable = (name) => {
        var _a;
        return (_a = appWindow.__APP__CUSTOM__) === null || _a === void 0 ? void 0 : _a[name];
    };
    return { setVariable, getVariable };
};
